module.exports = __webpack_public_path__ + "Octopus.87d099af4960c9e52db0ca1ba0b9718c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/GettingStarted/Octopus.svg
// module id = 630
// module chunks = 8